<template>
<div class="chapter">
<div class="inner_page">
<h2 class="chtit1">Contents</h2>
<p class="fmtoc"><a href="#/xhtml/preface">PREFACE</a></p>
<p class="fmtoc"><a href="#/xhtml/ack">ACKNOWLEDGMENTS</a></p>
<p class="toc"><a href="#/xhtml/ch001">1 SLOW, DIFFICULT, AND DANGEROUS TRAVEL</a></p>
<p class="toc"><span href="#/xhtml/ch002" title="Link target outside of Sample">2 A RAIL ROAD?</span></p>
<p class="toc"><span href="#/xhtml/ch003" title="Link target outside of Sample">3 KNOXVILLE, 1836</span></p>
<p class="toc"><span href="#/xhtml/ch004" title="Link target outside of Sample">4 SURVEYS, FINANCES, AND CONSTRUCTION</span></p>
<p class="toc"><span href="#/xhtml/ch005" title="Link target outside of Sample">5 CRISIS AND CONTRACTION</span></p>
<p class="toc"><span href="#/xhtml/ch006" title="Link target outside of Sample">6 WHAT HAPPENED</span></p>
<p class="toc"><span href="#/xhtml/ch007" title="Link target outside of Sample">7 WHAT MIGHT HAVE HAPPENED</span></p>
<p class="fmtocx"><span href="#/xhtml/notes" title="Link target outside of Sample">NOTES</span></p>
<p class="fmtocx"><span href="#/xhtml/index" title="Link target outside of Sample">INDEX</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?2ab55e48